module.exports = __webpack_public_path__ + "img/python.b9602f7f.png";